import Modal from "/WebInterface/new-ui/modules/modal.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import store from "/WebInterface/new-ui/manage-shares/js/reducer.js";
import { shareDetailsDataEditGridTemplate } from "/WebInterface/new-ui/manage-shares/modules/modals/edit-details/template.js";
import { editManageShareItem } from "/WebInterface/new-ui/manage-shares/utils/api.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import { translateComponent } from "/WebInterface/new-ui/modules/localizations/localizations.js";

// To invoke parent methods
function invoke(method, params) {
  if (parent.window[method]) {
    return parent.window[method].apply(this, params);
  }
}

export const initEditModal = (index, parentModal) => {
  const details = store.shareList[index];
  new Modal({
    title: "editShare",
    body: shareDetailsDataEditGridTemplate({
      remainingUsesText: t("remainingUses"),
      expiresText: t("expires"),
    }),
    hasResizeOption: true,
    movable: true,
    uniqueId: "manage-shares-edit-share-modal",
    minWidth: "550px",
    minHeight: "230px",
    translateComponentMethod: translateComponent,
    buttons: [
      {
        label: t("close"),
        close: true,
        classes: ["primary-button", "is-bordered"],
        onClick: () => {},
      },
      {
        label: t("ok"),
        close: true,
        classes: ["primary-button", "ml-3"],
        onClick: async () => {
          try {
            await editManageShareItem({
              tempUsername: `${details?.username};`,
              expire: `${_$("#date-picker").val()} ${_$("#time-picker").val()}`,
              logins: _$("#logins").val(),
            });

            parentModal?.hide(true);
            store.dispatch("refreshShareListing");
          } catch (error) {
            console.log(error);
          }
        },
      },
    ],
  });

  _$("#logins").val(details?.login_allowance);

  const manageShare_DateFormat = invoke("getUserCustomizationValue", [
    "manageShare_DateFormat",
    true,
  ]);
  let dateFormat = null;
  if (manageShare_DateFormat) {
    dateFormat = utils.dateStringFormat({
      format: manageShare_DateFormat,
      fromManageShares: true,
    });
  }

  const calendar = flatpickr("#date-picker", {
    dateFormat: dateFormat || "m/d/Y",
  });
  calendar.setDate(Number(details?.expireMillis));

  const timePickerElement = flatpickr("#time-picker", {
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i K",
  });
  timePickerElement.setDate(Number(details?.expireMillis));
};
